































import { Component, Vue } from "vue-property-decorator";
import { getReservationOrder } from "@/api/api.config";
@Component
export default class my_bookings extends Vue {
    isShow = true;
    show = false;
    loading = false;
    finished = false; //是否加载完成 加载完不在触发load事件
    refreshing = false; // 下拉状态
    userId: any = "";
    pageNum: any = 1;
    pageCount: any = 10;
    status: any = 0;
    list: any = [];



    getReservationOrderList() {
        getReservationOrder({
            page: this.pageNum,
            size: this.pageCount,
        }).then((res) => {
            this.list = res.data.data.content;
            if (res.data.data.totalElements === this.list.length) {
                this.finished = true;
            } else {
                this.finished = false;
            }
            this.pageNum++;
            this.refreshing = false;
            this.loading = false;
        });
    }

    onRefresh() {
        setTimeout(() => {
            this.list = [];
            this.pageNum = 1;
            this.getReservationOrderList();
        }, 1000);
    }

    toDetail(orderId: any) {
        this.$router.push({
            path: "my_booking_manage_details",
            query: { orderId: orderId },
        });
    }
    toReport(item: any) {
        if (item.productType === 0) {
            if (item.deviceFactoryId === "zqy") {
                this.$router.push({
                    path: `/bari`,
                    query: {
                        orderId: item.orderId,
                    },
                });
            } else {
                this.$router.push({
                    path: `/sgs`,
                    query: {
                        orderId: item.orderId,
                    },
                });
            }
        }
    }


    mounted() {
        this.getReservationOrderList();
    }

    onLoad() {

    }
    created() {
    }


}
